export default __webpack_public_path__ + "static/media/stabilityParameter_table.684a807a.png";